import {AxiosResponse} from "axios";

export interface UserData {
  profile: UserProfile;
}

export class UserProfile {
  id = "";
  firstName: string;
  lastName: string;
  login?: string;
  email: string;
  phone?: string;
  legacyUserId: string;
  tenantId: string;
  groups: string[];
  persistHandler: (token: string, userValues: UserProfile) => Promise<AxiosResponse>;
  generateTemporaryPassword?: (token: string, userId: string) => Promise<AxiosResponse>;

  constructor(
    id = "",
    firstName: string,
    lastName: string,
    login: string,
    email: string,
    phone: string,
    legacyUserId: string,
    tenantId: string,
    groups: string[],
    persistHandler: (token: string, userValues: UserProfile) => Promise<AxiosResponse>,
    generateTemporaryPassword?: (token: string, userId: string) => Promise<AxiosResponse>
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.login = login;
    this.email = email;
    this.phone = phone;
    this.legacyUserId = legacyUserId;
    this.tenantId = tenantId;
    this.groups = groups;
    this.persistHandler = persistHandler;
    this.generateTemporaryPassword = generateTemporaryPassword;
  }
}
